<template>
    <q-submenu v-if="buttons.length > 0" base-url="/lead_orders" :title="title" :titlelink="titlelink" :buttons="buttons" :submenu="submenu" class="q-sticky q-content-submenu"></q-submenu>
</template>

<script>
import QSubmenu from '@/components/navigation/Submenus/QSubmenu.vue'

export default {
    props: ["parentPath", "navMenuId"],
    data() {
        return {
            titlelink: [],
            submenu: [{
                label: "Help",
                to: "/page/frequently-asked-questions",
            }],
        }
    },
    computed: {
        buttons () {
            const buttons = []
            let items = this.findNavItemById(this.navMenuId)
            if (items === null) {
                items = this.findNavItemByPath()
            }
            if (items?.children && items?.children?.length > 0) {
                items.children.forEach((item) => {
                    buttons.push({
                        label: item.label,
                        to: item.to,
                        href: item.href,
                        icon: "fas fa-arrow-alt-circle-right"
                    })
                })
            } else if (items) {
                buttons.push({
                    label: items.label,
                    to: items.to,
                    href: items.href,
                    icon: "fas fa-arrow-alt-circle-right"
                })
            }
            return buttons
        },
        title () {
            let items = this.findNavItemById(this.navMenuId)
            if (items === null) {
                items = this.findNavItemByPath()
            }
            return items.label
        },
        filtered_menu: function() {
            var m = [];
            var g = this;
            this.user.nav_menu.forEach(function(item) {
                if (g.current_tenant.ID == item.tenant_id && item.menu == 'Left Nav') {
                    var _item = { ...item }
                    _item.children = [];
                    item.children.forEach(function(child) {
                        if (g.current_tenant.ID == child.tenant_id) {
                            _item.children.push(child)
                        }
                    })
                    m.push(_item);
                }
            })
            return m
        },
    },
    methods: {
        findNavItemById: function(id) {
            var items = null
            var found = false;
            this.filtered_menu.forEach(function(item) {
                if (found) {
                    return
                }
                if (item.id == id) {
                    items = item;
                    found = true;
                    return
                }
            })
            return items
        },

        findNavItemByPath () {
            let items
            this.filtered_menu.some(item => {
                if (this.matchRoute(item.to)) {
                    items = item
                    return true
                } else {
                    const hasInChildren = item.children.some(child => {
                        if (this.matchRoute(child.to)) {
                            items = item
                            return true
                        } else {
                            return false
                        }
                    })
                    if (hasInChildren) {
                        return true
                    }
                }
                return false
            })
            return items
        },
        matchRoute (to) {
            if (to === this.$route.path) { return true }
            if (Object.values(this.$route.params).length) { // edge case when the route path has params at the end
                let path = this.$route.path
                Object.values(this.$route.params).forEach(param => {
                    path = path.replace(`/${param}`, '')
                })
                return to === path
            }
            return false
        },
    },
    components: {
        QSubmenu
    },

    mounted() {
        if (this.$el.nodeType !== Node.ELEMENT_NODE) { return }

        this.resizeObserver = new ResizeObserver(([parent]) => {
            if (typeof this.$el.style != 'undefined'){
                this.$el.style.width = parent.contentRect.width + 'px'
            }
        });

        this.resizeObserver.observe(this.$el.parentElement);
    },

    beforeUnmounted() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    }
}
</script>

<style lang="scss" scoped>
  .q-content-submenu {
    transition: none !important;
    width: 100%;
    min-width: 0 !important;
  }
</style>